import { Button, makeStyles, MenuItem, TextField } from '@material-ui/core';
import Dialog from 'components/Dialog';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from 'react';
import { get100prStyle, getFormStyle, getRowStyle } from 'utils/functions';
import { connect, useDispatch } from 'react-redux';
import { closeAddTags, closeEditTags } from 'reducers/DialogsReducer';
import { getService } from 'reducers/service';
import { notify } from 'reducers/NotifierReducer';

const useStyles = makeStyles((theme) => ({
  autocomplete: {
    margin: '0 4px 8px',
  },
  option: {
    fontSize: 14,
  },
  row: getRowStyle(),
  w90: getFormStyle(90, 90),
  w100x200: getFormStyle(100, 200),
  w170x400: getFormStyle(170, 400),
  agency: getFormStyle(300, 600),
  date: getFormStyle(200, 300),
  w100pr: get100prStyle(),
  notes: {
    fontSize: 14,
  },
}));

const AddEditTag = (props) => {
  const dispatch = useDispatch();
  const { ptsEventID, ptsTagID, parentType, getTags } = props?.data;
  const classes = useStyles();
  const [type, setType] = useState('');
  const [value, setValue] = useState('');
  const [types, setTypes] = useState([]);

  useEffect(() => {
    getTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ptsTagID && types && !value && !type) getTagDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ptsTagID, types]);

  const getTagDetails = async () => {
    try {
      const service = await getService('ptstags');
      const tagData = await service.find({
        query: {
          ParentType: parentType,
          ptsParentID: ptsEventID,
          ptsTagID: ptsTagID,
          IsDeleted: false,
          $limit: 0,
        },
      });
      const tag = tagData?.data[0];
      setType(tag?.Type);
      setValue(tag?.Value);
    } catch (err) {
      props.handleError(err, 'Error receiving tag details.');
    }
  };

  const getTypes = async () => {
    try {
      const service = await getService('codetagtypes');
      const tagTypes = await service.find({
        query: {
          $limit: 0,
          IsDeleted: false,
          Parent: parentType,
        },
      });
      setTypes(
        tagTypes?.data?.map((tag) => ({ label: tag.Description, value: tag.Code, id: ptsTagID }))
      );
    } catch (err) {
      console.error('Error fetching types:', err);
    }
  };

  const onTypeChange = (ev) => {
    setType(ev.target.value);
  };

  const onValueChange = (ev) => {
    setValue(ev.target.value);
  };

  const close = () => {
    if (ptsTagID) props.closeEditTags();
    else props.closeAddTags();
  };

  const save = async () => {
    try {
      const service = await getService('ptstags');
      if (ptsTagID) {
        await service.patch(ptsTagID, {
          ParentType: parentType,
          ptsParentID: ptsEventID,
          Type: type,
          Value: value,
          IsLocked: false,
          IsSealed: false,
          IsDeleted: false,
        });
        dispatch(notify('Tag updated successfully', 'success'));
      } else {
        await service.create({
          ParentType: parentType,
          ptsParentID: ptsEventID,
          Type: type,
          Value: value,
          IsLocked: false,
          IsSealed: false,
          IsDeleted: false,
        });
        dispatch(notify('Tag added successfully', 'success'));
      }
      if (getTags) await getTags();
      close();
    } catch (err) {
      console.error('Error adding tag:', err);
      dispatch(notify('Error adding tag', 'error'));
    }
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" variant="contained" autoFocus onClick={save}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog
      toolbar
      onClose={close}
      title={ptsTagID ? 'Edit Tag' : 'Add Tag'}
      actions={renderActions()}>
      <div className={classes.row}>
        <TextField
          select
          className={classes.textField}
          label="Type"
          fullWidth
          value={type}
          onChange={onTypeChange}
          variant="outlined"
          size="small">
          {types.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className={classes.row}>
        <TextField
          label="Value"
          className={classes.textField}
          fullWidth
          variant="outlined"
          value={value}
          onChange={onValueChange}
        />
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    dictionary: state.dictionary,
  };
};

export default connect(mapStateToProps, {
  closeAddTags,
  closeEditTags,
})(AddEditTag);
